<template>
    <b-container>
        <b-row>
            <b-col md="12">
                <app-collapse
                accordion
                :type="'margin'"
                >
                <app-collapse-item v-for="(data, index) in content.faqs"   :key="index">
                    <template #header>
                        <b-container>
                        <b-row >
                            <b-col md="9">
                                {{ data.title === '' ? "Title here . . ." : data.title }}
                            </b-col>
                            <b-col md="3" class="d-flex justify-content-end">
                                <b-button
                                v-ripple.400="'rgba(234, 84, 85, 0.15)'"
                                variant="outline-danger"
                                size="sm"
                                @click="removeItem(index)"
                            >
                                <feather-icon
                                icon="XIcon"
                                class="mr-25"
                                />
                                <span>Delete</span>
                            </b-button>
                            </b-col>
                        </b-row>
                        </b-container>
                    </template>
                    <b-form-group>
                        <label for="name">Title</label>
                        <b-form-input
                            placeholder="Title here . . ."
                            v-model="data.title"
                        />
                    </b-form-group>
                    <!-- <quill-editor
                        :options="$store.getters['app/editorOptions']"
                        v-model="data.content"
                    /> -->
                    <snote v-model="data.content" ref="snote"/>
                </app-collapse-item>
                </app-collapse>
            </b-col>
        </b-row>
        <b-button
        v-ripple.400="'rgba(255, 255, 255, 0.15)'"
        variant="primary"
        @click="repeateAgain"
        >
        <feather-icon
            icon="PlusIcon"
            class="mr-25"
        />
        <span>Add New</span>
        </b-button>
    </b-container>
</template>

<script>
import AppCollapse from '@core/components/app-collapse/AppCollapse.vue'
import AppCollapseItem from '@core/components/app-collapse/AppCollapseItem.vue'
import { BContainer, BRow, BCol, BButton, BFormGroup, BFormInput } from 'bootstrap-vue'
// eslint-disable-next-line
import 'quill/dist/quill.core.css'
// eslint-disable-next-line
import 'quill/dist/quill.snow.css'
// eslint-disable-next-line
import 'quill/dist/quill.bubble.css'

import { quillEditor } from 'vue-quill-editor'
import Ripple from 'vue-ripple-directive'
import snote from './summernote.vue'

export default {
    props: {
        content: Object,
        options: Object,
        methods: Object,
        dropzoneElements: Object,
    },
    components: {
        BCol,
        BContainer,
        BRow,
        BButton,
        BFormGroup,
        BFormInput,
        quillEditor,
        AppCollapse,
        AppCollapseItem,
        'snote': snote
    },
    data() {
        return {
            nextTempId: 1,
            faqs: [

            ]
        }
    },
    directives: {
        Ripple,
    },
    methods: {
        repeateAgain() {
            this.content.faqs.push({
                tempId: this.nextTempId++,
                title: "",
                content: ""
            })
        },
        removeItem(index) {
            this.content.faqs.splice(index, 1)
        },
        updateEditor() {
            if (this.$refs.snote) {
                this.$refs.snote.forEach(element => element.updateEditor())
            }
        }
    }
}
</script>

<style>

</style>